import React from "react";
import { Col, Row } from "react-bootstrap";
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import di from "../../../di/serviceLocator";
var SaveMandate = function (props) {
    var SavedMandateColumn = [
        {
            columnName: "Send To Email",
            key: "raEmail",
        },
        {
            columnName: "MandateId",
            key: "mandateId",
        },
        {
            columnName: "ClientId",
            key: "clientId",
        },
        {
            columnName: "Client Name",
            key: "clientName",
        },
        {
            columnName: "Bank Name",
            key: "bankName",
        },
        {
            columnName: "Bank Account No",
            key: "bankAccNo",
        },
        {
            columnName: "Branch Name",
            key: "branch",
        },
        {
            columnName: "Amount",
            key: "amount",
        },
        {
            columnName: "Source",
            key: "source",
        },
        {
            columnName: "Mandate Type",
            key: "mandateType",
        },
        {
            columnName: "Request Date",
            key: "reqDate",
        },
        {
            columnName: "Mandate Date",
            key: "mand_Date",
        },
        {
            columnName: "Send Mandate Form",
            key: "mandateId",
            tdCustomFunction: function (key) {
                return (React.createElement(EdButton, { btnTyp: "midnight-blue", type: "button", value: "Send Mail", onClick: function () { return sendMail(key); }, className: "send_mail", slim: true }));
            },
        },
    ];
    var sendMail = function (id) {
        var reqData = props.mandateDetails.find(function (x) { return x.mandateId === id; });
        di.clients
            .sendMandateMail(reqData)
            .then(function (data) { return alert("Mail Send"); })
            .catch(function (err) { return alert("Failed to Send Mail"); });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "relationship-head-block mx-0 px-0" },
            React.createElement(Col, { className: "DMSanBold_18_700 txt_blackOne1 px-0" }, "Saved Mandate")),
        React.createElement(GenericTable, { columns: SavedMandateColumn, data: props.mandateDetails, parentClassName: "salestableParentClass table-responsive commonscroll-new", tableClassName: "salestableclass" })));
};
export default SaveMandate;
